import React from "react";
import { styles } from "./StickyBar.style";
import { Button } from "../../elements/Button";
import { Icon } from "../../elements/Icon";
import { LinkButton } from "../../elements/LinkButton/LinkButton";

export interface StickyBarProps {
  visible: boolean;
  linkButtonHref?: string;
  onButtonClick?: React.MouseEventHandler;
  buttonTestSelector?: string;
  iconPath?: string;
  buttonText: string;
}

export const StickyBar = ({
  visible,
  linkButtonHref,
  onButtonClick,
  buttonTestSelector,
  iconPath,
  buttonText,
}: StickyBarProps) => {
  const content = (
    <>
      {iconPath && <Icon icon={iconPath} size={20} />}
      {buttonText}
    </>
  );

  return (
    <div className={styles.root(visible)}>
      {linkButtonHref ? (
        <LinkButton
          href={linkButtonHref}
          onClick={onButtonClick}
          className={styles.button()}
          testSelector={buttonTestSelector}
        >
          {content}
        </LinkButton>
      ) : (
        <Button className={styles.button()} onClick={onButtonClick} testSelector={buttonTestSelector}>
          {content}
        </Button>
      )}
    </div>
  );
};
